module.exports = require("@mui/icons-material/Remove");